const TRUNCATE_LENGTH = 280

const historySliderEl = document.querySelector('.history-carousel__slider')

if (historySliderEl) {
	const wrapper = historySliderEl.querySelector('.swiper-wrapper')
	const track = document.querySelector('.history-carousel__dots-track')
	const dots = [...document.querySelectorAll('.history-carousel__dot')]
	const prevBtn = document.querySelector('.history-carousel__arrow--prev')
	const nextBtn = document.querySelector('.history-carousel__arrow--next')
	const line = document.querySelector('.history-carousel__line')

	const getRealSlides = () => [...wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide--empty)')]

	const getRealSlidesCount = () => getRealSlides().length

	const getLastRealIndex = () => Math.max(getRealSlidesCount() - 1, 0)

	const getEmptySlidesCount = () => {
		if (window.innerWidth >= 1400) return 3
		if (window.innerWidth >= 768) return 2
		return 2
	}

	const removeEmptySlides = () => {
		wrapper.querySelectorAll('.swiper-slide--empty').forEach(slide => slide.remove())
	}

	const addEmptySlides = () => {
		const emptyCount = getEmptySlidesCount()

		for (let i = 0; i < emptyCount; i++) {
			const emptySlide = document.createElement('div')
			emptySlide.className = 'history-carousel__slide swiper-slide swiper-slide--empty'
			emptySlide.setAttribute('aria-hidden', 'true')
			wrapper.appendChild(emptySlide)
		}
	}

	const setActiveDot = index => {
		dots.forEach((dot, i) => {
			dot.classList.toggle('is-active', i === index)
		})
	}

	const moveDots = index => {
		if (!track || !dots.length) return

		const firstDot = dots[0]
		const dotWidth = firstDot.offsetWidth
		const gap = parseFloat(window.getComputedStyle(track).gap) || 0
		const offset = index * (dotWidth + gap)

		track.style.transform = `translateX(-${offset}px)`
	}

	const updateLine = () => {
		if (!line || !dots.length) return

		const dotWidth = dots[0].offsetWidth
		const gap = parseFloat(window.getComputedStyle(track).gap) || 0
		const lastIndex = dots.length - 1

		const lineWidth = lastIndex * (dotWidth + gap)

		line.style.width = `${lineWidth}px`
	}

	const updateArrows = index => {
		const lastIndex = getLastRealIndex()
		const isStart = index <= 0
		const isEnd = index >= lastIndex

		prevBtn?.classList.toggle('is-disabled', isStart)
		nextBtn?.classList.toggle('is-disabled', isEnd)

		prevBtn?.setAttribute('aria-disabled', String(isStart))
		nextBtn?.setAttribute('aria-disabled', String(isEnd))
	}

	const syncSliderState = swiper => {
		const lastRealIndex = getLastRealIndex()
		const safeIndex = Math.min(swiper.activeIndex, lastRealIndex)

		if (swiper.activeIndex > lastRealIndex) {
			swiper.slideTo(lastRealIndex, 0)
		}

		setActiveDot(safeIndex)
		moveDots(safeIndex)
		updateArrows(safeIndex)
	}

	removeEmptySlides()
	addEmptySlides()

	const historySwiper = new Swiper(historySliderEl, {
		loop: false,
		speed: 600,
		spaceBetween: 24,
		slidesPerView: 'auto',
		slidesPerGroup: 1,
		centeredSlides: false,
		watchOverflow: true,

		navigation: {
			nextEl: nextBtn,
			prevEl: prevBtn,
		},

		breakpoints: {
			768: {
				spaceBetween: 150,
			},
			1400: {
				spaceBetween: 150,
			},
		},

		on: {
			init(swiper) {
				syncSliderState(swiper)
				updateLine()
			},
			slideChange(swiper) {
				syncSliderState(swiper)
			},
		},
	})

	nextBtn?.addEventListener('click', e => {
		if (historySwiper.activeIndex >= getLastRealIndex()) {
			e.preventDefault()
			historySwiper.slideTo(getLastRealIndex())
		}
	})

	prevBtn?.addEventListener('click', e => {
		if (historySwiper.activeIndex <= 0) {
			e.preventDefault()
			historySwiper.slideTo(0)
		}
	})

	dots.forEach(dot => {
		dot.addEventListener('click', () => {
			const index = Number(dot.dataset.index)

			if (Number.isNaN(index)) return

			const safeIndex = Math.min(index, getLastRealIndex())
			historySwiper.slideTo(safeIndex)
		})
	})

	let resizeTimeout = null

	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout)

		resizeTimeout = setTimeout(() => {
			const currentIndex = Math.min(historySwiper.activeIndex, getLastRealIndex())

			removeEmptySlides()
			addEmptySlides()
			historySwiper.update()
			historySwiper.slideTo(currentIndex, 0)

			syncSliderState(historySwiper)
			updateLine()
		}, 150)
	})
}

const referencesEl = document.querySelector('.references-carousel__swiper')

if (referencesEl) {
	const referencesSwiper = new Swiper(referencesEl, {
		loop: true,
		centeredSlides: true,
		slidesPerView: 2.5,
		spaceBetween: 24,
		speed: 1000,
		slideToClickedSlide: true,

		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},

		breakpoints: {
			768: {
				slidesPerView: 'auto',
				spaceBetween: 150,
			},
		},

		on: {
			init(swiper) {
				updateRefContent(swiper)
			},
			slideChange(swiper) {
				updateRefContent(swiper)
			},
		},
	})

	const refContent = document.querySelector('.references-carousel__content')
	if (refContent) {
		refContent.addEventListener('mouseenter', () => referencesSwiper.autoplay.stop())
		refContent.addEventListener('mouseleave', () => referencesSwiper.autoplay.start())
	}
}

function updateRefContent(swiper) {
	const activeSlide = swiper.slides?.[swiper.activeIndex]
	if (!activeSlide) return

	const root = swiper.el.closest('.references-carousel')
	if (!root) return

	const text = activeSlide.dataset.text || ''
	const company = activeSlide.dataset.company || ''
	const who = activeSlide.dataset.who || ''

	const textEl = root.querySelector('.references-carousel__text')
	const companyEl = root.querySelector('.references-carousel__company')
	const whoEl = root.querySelector('.references-carousel__who')

	if (companyEl) companyEl.textContent = company
	if (whoEl) whoEl.textContent = who

	if (!textEl) return

	const existingBtn = root.querySelector('.references-carousel__read-more')
	if (existingBtn) existingBtn.remove()

	const needsTruncate = text.length > TRUNCATE_LENGTH
	const shortText = needsTruncate ? text.slice(0, TRUNCATE_LENGTH).trimEnd() + '…' : text

	textEl.textContent = `„${shortText}"`

	if (!needsTruncate) return

	const btn = document.createElement('button')
	btn.className = 'references-carousel__read-more button button--ghost'
	btn.textContent = statlookI18n.readMore
	btn.setAttribute('aria-expanded', 'false')

	let expanded = false

	btn.addEventListener('click', () => {
		expanded = !expanded
		textEl.textContent = expanded ? `„${text}"` : `„${shortText}"`
		btn.textContent = expanded ? statlookI18n.readLess : statlookI18n.readMore
		btn.setAttribute('aria-expanded', String(expanded))
	})

	textEl.insertAdjacentElement('afterend', btn)
}
